import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useUpdateClientMutation } from '@/modules/common/queries/clients.ts';
import {
  ClientFormValues,
  ClientModal,
} from '@/modules/admin-dashboard/components/modals/ClientModal.tsx';
import { BaseModalProps } from 'ui';

interface EditClientModalProps extends BaseModalProps {
  client: {
    id: number;
    name: string;
    phone_number?: string;
    email?: string;
  };
}

const clientValidationSchema = Yup.object().shape({
  name: Yup.string().required('Client name is required'),
  email: Yup.string().email('Invalid email address'),
  phone_number: Yup.string(),
});

export const EditClientModal = ({ open, onClose, client }: EditClientModalProps) => {
  const { mutateAsync: updateClient, isLoading } = useUpdateClientMutation();

  const formik = useFormik<ClientFormValues>({
    initialValues: {
      name: client.name,
      phone_number: client.phone_number || '',
      email: client.email || '',
    },
    validationSchema: clientValidationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async values => {
      await updateClient({
        id: client.id,
        data: {
          name: values.name.trim(),
          phone_number: values.phone_number.trim() || undefined,
          email: values.email.trim() || undefined,
        },
      });
      onClose();
    },
  });

  return (
    <ClientModal
      open={open}
      onClose={onClose}
      formik={formik}
      isSubmitting={isLoading}
      isEditMode
    />
  );
};
